import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

const RowWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const StyledSkeleton = styled(Skeleton)`
  margin-top: ${spacing.half};
  margin-bottom: ${spacing.half};
`;

export const TableSkeleton = () => (
  <>
    {[0, 1, 2, 3, 4, 5, 6, 7].map((idx) => (
      <RowWrapper key={idx}>
        <StyledSkeleton key={`skeleton-row-item`} height={50} shimmerSpeed={4500} />
      </RowWrapper>
    ))}
  </>
);
